import React from 'react';
import { Routes, Route } from 'react-router-dom';
import PropTypes from 'prop-types';

import AccountShopManagement from './AccountShopManagement.js';
import { SHOP_STATUS } from '../../helper/index.js';

function AccountShop(props) {
  return (
    <Routes>
      <Route
        path='/accountapproved'
        element={
          <AccountShopManagement
            filter={SHOP_STATUS.APPROVED}
            app_hostname={props.app_hostname}
            permitdata={props.permitdata}
          />
        }
      />
      <Route
        path='/accountpending'
        element={
          <AccountShopManagement
            filter={SHOP_STATUS.PENDING}
            app_hostname={props.app_hostname}
            permitdata={props.permitdata}
          />
        }
      />
      <Route
        path='/accountsuspended'
        element={
          <AccountShopManagement
            filter={SHOP_STATUS.SUSPENDED}
            app_hostname={props.app_hostname}
            permitdata={props.permitdata}
          />
        }
      />
    </Routes>
  );
}

AccountShop.propTypes = {
  app_hostname: PropTypes.string.isRequired,
  permitdata: PropTypes.shape({
    token: PropTypes.string.isRequired,
  }).isRequired,
};

export default AccountShop;
